
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tarot-typology",
      function () {
        return require("private-next-pages/tarot-typology/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tarot-typology"])
      });
    }
  